import { Customer } from '@squareup/sq-addons-web-sdk';

export enum RequestContext {
  BARCODE_SCANNER,
  CHECK_IN_CODE,
  SDK,
  SEARCH_CUSTOMERS,
}

export interface CustomerState {
  customer?: Customer;
  pointBalance?: number;
  isAddedToSale: boolean;
  context?: RequestContext;
  addCustomerToSaleState: {
    isPending: boolean;
    error?: Error;
  };
  removeCustomerFromSaleState: {
    isPending: boolean;
    error?: Error;
  };
  enrollCustomerState: {
    isPending: boolean;
    apiSuccess?: boolean;
    error?: Error;
  };
  getCustomerState: {
    isPending: boolean;
    apiSuccess?: boolean;
    error?: Error;
  };
}

export const ENROLL_CUSTOMER = 'ENROLL_CUSTOMER';
export const ENROLL_CUSTOMER_FULFILLED = 'ENROLL_CUSTOMER_FULFILLED';
export const ENROLL_CUSTOMER_REJECTED = 'ENROLL_CUSTOMER_REJECTED';
export const ENROLL_CUSTOMER_STATE_RESET = 'ENROLL_CUSTOMER_STATE_RESET';

export const ADD_CUSTOMER = 'ADD_CUSTOMER';
export const ADD_CUSTOMER_TO_SALE = 'ADD_CUSTOMER_TO_SALE';
export const ADD_CUSTOMER_TO_SALE_FULFILLED = 'ADD_CUSTOMER_TO_SALE_FULFILLED';
export const ADD_CUSTOMER_TO_SALE_REJECTED = 'ADD_CUSTOMER_TO_SALE_REJECTED';

export const GET_CUSTOMER = 'GET_CUSTOMER';
export const GET_CUSTOMER_FULFILLED = 'GET_CUSTOMER_FULFILLED';
export const GET_CUSTOMER_REJECTED = 'GET_CUSTOMER_REJECTED';
export const GET_CUSTOMER_STATE_RESET = 'GET_CUSTOMER_STATE_RESET';

export const RESET_CUSTOMER = 'RESET_CUSTOMER';
export const REMOVE_CUSTOMER_FROM_SALE = 'REMOVE_CUSTOMER_FROM_SALE';
export const REMOVE_CUSTOMER_FROM_SALE_FULFILLED =
  'REMOVE_CUSTOMER_FROM_SALE_FULFILLED';
export const REMOVE_CUSTOMER_FROM_SALE_REJECTED =
  'REMOVE_CUSTOMER_FROM_SALE_REJECTED';

export const SET_POINT_BALANCE = 'SET_POINT_BALANCE';

export type EnrollCustomerAction = {
  type: typeof ENROLL_CUSTOMER;
  payload: {
    phoneNumber: string;
  };
};

export type EnrollCustomerFulfilledAction = {
  type: typeof ENROLL_CUSTOMER_FULFILLED;
};

export type EnrollCustomerRejectedAction = {
  type: typeof ENROLL_CUSTOMER_REJECTED;
  payload: {
    error: Error;
  };
};

export type EnrollCustomerStateResetAction = {
  type: typeof ENROLL_CUSTOMER_STATE_RESET;
};

export type AddCustomerAction = {
  type: typeof ADD_CUSTOMER;
  payload: {
    customer: Customer;
    context: RequestContext;
  };
};

export type AddCustomerToSaleAction = {
  type: typeof ADD_CUSTOMER_TO_SALE;
  payload: {
    customer: Customer;
  };
};

export type AddCustomerToSaleFulfilledAction = {
  type: typeof ADD_CUSTOMER_TO_SALE_FULFILLED;
};

export type AddCustomerToSaleRejectedAction = {
  type: typeof ADD_CUSTOMER_TO_SALE_REJECTED;
  payload: {
    error: Error;
  };
};

export type GetCustomerAction = {
  type: typeof GET_CUSTOMER;
  payload: {
    referenceId?: string;
    context: RequestContext;
  };
};

export type GetCustomerFulfilledAction = {
  type: typeof GET_CUSTOMER_FULFILLED;
};

export type GetCustomerRejectedAction = {
  type: typeof GET_CUSTOMER_REJECTED;
  payload: {
    context: RequestContext;
    error: Error;
  };
};

export type GetCustomerStateResetAction = {
  type: typeof GET_CUSTOMER_STATE_RESET;
};

export type ResetCustomerAction = {
  type: typeof RESET_CUSTOMER;
};

export type RemoveCustomerFromSaleAction = {
  type: typeof REMOVE_CUSTOMER_FROM_SALE;
};

export type RemoveCustomerFromSaleFulfilledAction = {
  type: typeof REMOVE_CUSTOMER_FROM_SALE_FULFILLED;
};

export type RemoveCustomerFromSaleRejectedAction = {
  type: typeof REMOVE_CUSTOMER_FROM_SALE_REJECTED;
  payload: {
    error: Error;
  };
};

export type SetPointBalanceAction = {
  type: typeof SET_POINT_BALANCE;
  payload: {
    pointBalance: number;
  };
};

export type CustomerActionTypes =
  | EnrollCustomerAction
  | EnrollCustomerFulfilledAction
  | EnrollCustomerRejectedAction
  | EnrollCustomerStateResetAction
  | AddCustomerAction
  | AddCustomerToSaleAction
  | AddCustomerToSaleFulfilledAction
  | AddCustomerToSaleRejectedAction
  | GetCustomerAction
  | GetCustomerFulfilledAction
  | GetCustomerRejectedAction
  | GetCustomerStateResetAction
  | ResetCustomerAction
  | RemoveCustomerFromSaleAction
  | RemoveCustomerFromSaleFulfilledAction
  | RemoveCustomerFromSaleRejectedAction
  | SetPointBalanceAction;
